import React,{ useState } from 'react'
import "../singleCareer/single.scss"
import { Link } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';
import { active } from '../../redux/dataSlice1';
import { axiosInstance } from '../../config';
import Spinner from '../../components/spinner';

const SingleIntern = () => {

  const [info, setInfo] = useState();
  const [updated, setUpdated] = useState(false);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.value);

  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleUpdate = async (id, e) => {
    e.preventDefault();
    try{
        const updatedIntern = { ...info }
        const update = await axiosInstance.put(`/internship-form/${id}`, updatedIntern)
        setInfo({});
        dispatch(active(update.data))
        setUpdated(true);
    }catch(err){
        console.log(err);
    }
  }

  return (
    <div>
      {
        !data && <Spinner/>
      }
    {data && 
    <div className='single'>
        <div className='top'>
          <p>Internship Form Details</p>
          <Link to='/internships'> 
            <button className='Btn'>Back</button>
          </Link>
        </div>
        <div className="client">
          <div className="userShow">
            <div className="userShowTop">
              <div className="userShowTopTitle">
                <span className="userShowFullname">{data.name}</span>
              </div>
            </div>
            <div className="userShowBottom">
              <div className="userShowInfo">
                <span>Status: </span>
                <span className="userShowInfoTitle">{data.status}</span>
              </div>
              <div className="userShowInfo">
                <span>Email: </span>
                <span className="userShowInfoTitle">{data.email}</span>
              </div>
              <div className="userShowInfo">
                <span>Phone: </span>
                <span className="userShowInfoTitle">{data.phone}</span>
              </div>
              <div className="userShowInfo">
                <span>Address: </span>
                <span className="userShowInfoTitle">{data.address}</span>
              </div>
              <div className="userShowInfo">
                <span>Position applied: </span>
                <span className="userShowInfoTitle">{data.position}</span>
              </div>
              <div className="userShowInfo">
                <span>Qualifications: </span>
                <span className="userShowInfoTitle">{data.qualification}</span>
              </div>
              <div className="userShowInfo">
                <span>Experience: </span>
                <span className="userShowInfoTitle">{data.experience}</span>
              </div>
              <div className="userShowInfo">
                <span>Exam: </span>
                <span className="userShowInfoTitle">{data.exam}</span>
              </div>
              <div className="userShowInfo">
                <span>Subject: </span>
                <span className="userShowInfoTitle">{data.subject}</span>
              </div>
              <div className="userShowInfo">
                <span>Language: </span>
                <span className="userShowInfoTitle">{data.language}</span>
              </div>
              <div className="userShowInfo">
                <span>Demo Link: </span>
                {
                    data.demolink && 
                    <span className="userShowInfoTitle"><a href={`${data.demolink}`} target="_blank" rel="noopener noreferrer">View</a></span>
                }
              </div>
              <div className="userShowInfo">
                <span>YouTube Link: </span>
                {
                    data.youtubelink && 
                    <span className="userShowInfoTitle"><a href={`${data.youtubelink}`} target="_blank" rel="noopener noreferrer">View</a></span>
                }
              </div>
            </div>
          </div>
          <div className="userUpdate">
            <span className="userUpdateTitle">EDIT</span>
            {updated && (
                <p className='updated'>
                  <span>Details Updated Successfully!</span>
                  <span onClick={() => setUpdated(false)} style={{ cursor: 'pointer' }} >X</span>
                </p>
            )}
            <form className="userUpdateForm">
              <div className="userUpdateLeft">
                <div className="userUpdateItem">
                  <label>Email</label>
                  <input
                    type="text"
                    id = "email"
                    onChange={handleChange}
                    placeholder={data.email}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Phone</label>
                  <input
                    type="text"
                    id = "phone"
                    onChange={handleChange}
                    placeholder={data.phone}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Position Applied For:</label>
                  <input
                    type="text"
                    id = "position"
                    onChange={handleChange}
                    placeholder={data.position}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Qualification:</label>
                  <input
                    type="text"
                    id = "qualification"
                    onChange={handleChange}
                    placeholder={data.qualification}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Experience:</label>
                  <input
                    type="text"
                    id = "experience"
                    onChange={handleChange}
                    placeholder={data.experience}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Exam:</label>
                  <input
                    type="text"
                    id = "exam"
                    onChange={handleChange}
                    placeholder={data.exam}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Subject:</label>
                  <input
                    type="text"
                    id = "subject"
                    onChange={handleChange}
                    placeholder={data.subject}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Language:</label>
                  <input
                    type="text"
                    id = "language"
                    onChange={handleChange}
                    placeholder={data.language}
                    className="userUpdateInput"
                  />
                </div>
                <div className="userUpdateItem">
                  <label>Status</label>
                  <select name="status" onChange={handleChange} id="status">
                    <option value={data.status}>Select</option>
                    <option value="New">New</option>
                    <option value="In-process">In-process</option>
                    <option value="Discarded">Discarded</option>
                  </select>
                </div>
                <button className="userUpdateButton" onClick={(e) => handleUpdate(data._id, e)}>Update</button>
              </div>
            </form>
          </div>
        </div>
    </div>
    }
    </div>
  )
}

export default SingleIntern